<template>
  <button class="skip-intro-button" @click="skipIntro" v-if="showSkipIntroButton">Skip Intro</button>
</template>

<script>
export default {
  props: ['videoPlaying','currentPlayerTime', 'player', 'videoIntro'],
  data(){
    return {
      showSkipBtnAfter: 2,
      showSkipIntroButton: false,
    }
  },
  watch:{
    currentPlayerTime: {
      handler() {
        if(this.currentPlayerTime > this.showSkipBtnAfter) {
          this.showSkipIntroButton = this.currentPlayerTime < this.videoIntro;
        } else {
          this.showSkipIntroButton = false
        }
      },
      deep: true
    },
  },
  methods: {
    skipIntro() {
      this.player.currentTime(this.videoIntro);
    },
  }
}
</script>
<style scoped>
.skip-intro-button {
  position: absolute;
  bottom: 100px;
  right: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  z-index: 9999;
}
</style>
